

import React, { useState, useEffect } from "react";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { QRCodeCanvas } from "qrcode.react";
import { API_PATH } from "../../Constant/constant";
import { useParams } from "react-router-dom";  
 
import { IMG_URL } from "./Imageurl";
import * as Constants from "../../Constant/constant";

const LibraryCard = () => {



const { id } = useParams();
  const [cardData, setCardData] = useState(null);
  const [libraryName, setLibraryName] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);
  const [libraries, setLibraries] = useState([]);
  const [error, setError] = useState(null);

  // Fetch card data
  useEffect(() => {
    if (id) {
      axios
        .get(`${API_PATH}/library_card/${id}`)
        .then((res) => {
          setCardData(res.data);

          if (res.data?.library_id) {
            axios
              .get(`${API_PATH}/library/${res.data.library_id}`)
              .then((res2) => setLibraryName(res2.data.name))
              .catch((err) => console.error("Library fetch error:", err));
          }
        })
        .catch((err) => console.error("Card fetch error:", err));
    }
  }, [id]);

  // Fetch libraries
  const fetchLibraries = async () => {
    try {
      const response = await axios.get(Constants.API_PATH + `/add_new_library_data`);
      setLibraries(response.data);
    } catch (error) {
      console.error("Error fetching libraries:", error);
      setError("Failed to fetch libraries.");
    }
  };

  useEffect(() => {
    if (cardData) {
      fetchLibraries();
    }
  }, [cardData])

  if (!cardData) return <p className="text-center mt-5">Loading card...</p>;

  // Issue & Expiry Dates
  const issueDate = new Date();
  const expiryDate = new Date();
  expiryDate.setFullYear(expiryDate.getFullYear() + 1);



const printCard = async () => {
  const front = document.getElementById("card-front");
  const back = document.getElementById("card-back");

  // Temporarily fix back rotation
  const originalTransform = back.style.transform;
  back.style.transform = "rotateY(0deg)";

  const frontCanvas = await html2canvas(front, { scale: 2, useCORS: true });
  const backCanvas = await html2canvas(back, { scale: 2, useCORS: true });

  // Restore rotation
  back.style.transform = originalTransform;

  const frontImg = frontCanvas.toDataURL("image/png");
  const backImg = backCanvas.toDataURL("image/png");

  // Open print window
  const printWindow = window.open("", "_blank");
  


  printWindow.document.write(`
  <html>
    <head>
      <title>Print Library Card</title>
      <style>
        @page {
          size: 90mm 120mm;   /* 1 card width, 2 cards stacked vertically */
          margin: 0;
        }
        body {
          margin: 0;
          padding: 0;
          text-align: center;
          font-family: Arial, sans-serif;
        }
        .card-sheet {
          width: 90mm;
          height: 120mm;
          display: flex;
          flex-direction: column;   
          justify-content: space-between;
          align-items: center;
        }
        .card {
          width: 90mm;
          height: 60mm;
        }
        .card img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
          object-fit: cover;
        }
      </style>
    </head>
    <body>
      <div class="card-sheet">
        <div class="card"><img src="${frontImg}" /></div>
        <div class="card"><img src="${backImg}" /></div>
      </div>
      <script>
        window.onload = function() {
          window.print();
        }
      </script>
    </body>
  </html>
`);

  printWindow.document.close();
};
  const getLibraryName = (id) => {
    const lib = libraries.find((library) => library.id === id);
    return lib ? lib.library_name : "Unknown Library";
  };








  return (
 



        <div style={{ textAlign: "center", margin: "0 auto", width: "50%" }}>
      <h2>📚 Your Library Card</h2>

      {/* Card Container */}
      <div
        style={{
          perspective: "1000px",
          margin: "20px auto",
          width: "360px",
          height: "240px",
          cursor: "pointer",
        }}
        onClick={() => setIsFlipped(!isFlipped)}
      >
        {/* Inner wrapper for flip */}
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            transformStyle: "preserve-3d",
            transition: "transform 0.8s",
            transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* Front Side */}
          <div
            id="card-front"
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid #004080",
              borderRadius: "12px",
              padding: "12px",
              position: "absolute",
              backfaceVisibility: "hidden",
              background: "linear-gradient(to right, #d9f0ff, #f9fcff)",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #004080",
                paddingBottom: "5px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={IMG_URL} alt="Logo" style={{ width: "40px", marginRight: "10px",fontSize:"1.3rem" }} />
                <h4 style={{ margin: 0, color: "#004080" }}>{getLibraryName(cardData.library_id)}</h4>
              </div>
              
            </div>

              <div>
              <span style={{ fontSize: "12px", fontWeight: "bold", color: "#004080" }}>
                Library Card
              </span>
              </div>  

            {/* User Info row: image left, details right */}
            <div style={{ display: "flex", marginTop: "10px", alignItems: "flex-start" }}>
            
              <img
                src={`https://libtest.jaipuriaschools.com/${cardData.user_img}`}
                alt="Profile"
                crossOrigin="anonymous"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "10%",
                  border: "2px solid #004080",
                  marginRight: "12px",
                }}
              />
              <div style={{ textAlign: "left", fontSize: "13px", lineHeight: "0.4" }}>
                <p>
                  <b>Id:</b> {cardData.unique_id}
                </p>
                <p>
                  <b>Name:</b> {cardData.first_name} {cardData.last_name}
                </p>
                <p>
                  <b>Email:</b> {cardData.email}
                </p>
                <p>
                  <b>Mobile:</b> {cardData.mobile_no}
                </p>
                {/* <p>
                  <b>Issue:</b> {cardData.issue_date}
                </p>
                <p>
                  <b>Expiry:</b> {cardData.expiry_date}
                </p> */}
              </div>

            </div>
<div
  style={{
    position: "absolute",
    
    bottom: "8px",      // distance from bottom
    right: "12px",      // distance from right
    textAlign: "center",
   // top: "170px"
  }}
>
   <p
    style={{
      fontSize: "12px",
      margin: 0,
      color: "#004080",
      fontWeight: "bold",
      marginTop: "10px"
    }}
  >
    Auth Sign
  </p>
  <img
    src="/signature.png"   // 👉 replace with your signature image path
    alt="Signature"
    style={{
      width: "100px",
      height: "40px",
      objectFit: "contain",
      //marginTop: "px",
      marginBottom: "0px"
    }}
  />
 
</div>
          </div>

          {/* Back Side */}
          <div
            id="card-back"
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid #004080",
              borderRadius: "12px",
              padding: "12px",
              position: "absolute",
              backfaceVisibility: "hidden",
              background: "linear-gradient(to right, #f9fcff, #d9f0ff)",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
              fontFamily: "Arial, sans-serif",
              transform: "rotateY(180deg)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h4 style={{ color: "#004080" }}>Scan QR for Details</h4>
            <div id="qr-code">
              <QRCodeCanvas
                  value={`Id: ${cardData.unique_id}\nName: ${cardData.first_name} ${cardData.last_name}\nEmail: ${cardData.email}\nMobile: ${cardData.mobile_no}\nLibrary Name:${getLibraryName(cardData.library_id)}`}
                size={120}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"H"}
                includeMargin={true}
              />
            </div>
            <p style={{ fontSize: "10px", marginTop: "6px", color: "#333" }}>
              Community Library System
            </p>
          </div>
        </div>
      </div>

      {/* <button
        onClick={downloadCard}
        style={{
          marginTop: "12px",
          padding: "8px 15px",
          borderRadius: "5px",
          background: "#28a745",
          color: "white",
          border: "none",
          cursor: "pointer",
        }}
      >
        ⬇ Download as PDF (Front + Back)
      </button> */}

      <button
  onClick={printCard}
  style={{
    marginTop: "12px",
    marginLeft: "10px",
    padding: "8px 15px",
    borderRadius: "5px",
    background: "#007bff",
    color: "white",
    border: "none",
    cursor: "pointer"
  }}
>
  🖨 Print Card
</button>

    </div>
  );

};

export default LibraryCard;

